import React from 'react';

import { Field, Form, FormikErrors } from 'formik';

import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TranslationHelper from '../../../../helpers/TranslationHelper';

import { useStyles } from './Themable.hooks';

import FieldWrapper from '../../../../components/common/formikWrappers/FieldWrapper';
import { useSelectedTicketAvailableStatuses } from '../../state/index.hooks';
import { IWorkflowStatus } from '../../types';
import { renderMenuItems } from '../../../../helpers/renderMenuItems';
import { IUser } from '../../../../state/app/collections/dataTypes';
import { useUsersList } from '../../../../state/app/collections/index.hooks';
import { IconButton, InputAdornment } from '@mui/material';

interface ITicketForm {
    name: string;
    notice: string;
    description: string;
    status: number;
}

interface IOwnProps {
    errors?: FormikErrors<ITicketForm>;
    setFieldValue: (field: string, value: any) => void;
}
const TicketForm = ({ errors, setFieldValue }: IOwnProps) => {
    const classes = useStyles();
    const statuses = useSelectedTicketAvailableStatuses();

    const users = useUsersList();
    const commonProps = {
        fullWidth: true,
        component: FieldWrapper,
    };

    const handleReset = () => {
        setFieldValue('assignedUser', null);
    };
    return (
        <Form>
            <div className={classes.formWrapper}>
                <Field
                    error={!!errors?.name}
                    helperText={errors?.name}
                    name={'name'}
                    label={TranslationHelper.translate('Name')}
                    type={'text'}
                    required={true}
                    {...commonProps}
                />
                <Field
                    error={!!errors?.status}
                    helperText={errors?.status}
                    name={'status'}
                    label={TranslationHelper.translate('Status')}
                    select={true}
                    fullWidth={true}
                    component={FieldWrapper}
                    required={true}
                >
                    {renderMenuItems(
                        statuses || [],
                        (item: IWorkflowStatus) => {
                            return {
                                id: item.name,
                                name: item.label,
                            };
                        }
                    )}
                </Field>
                <Field
                    name="assignedUser"
                    label={TranslationHelper.translate('Assigned user')}
                    select
                    fullWidth
                    component={FieldWrapper}
                    SelectProps={{
                        IconComponent: (props: any) => (
                            <ArrowDropDownIcon
                                {...props}
                                style={{ marginRight: 28 }}
                            />
                        ),
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    color="primary"
                                    onClick={handleReset}
                                >
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                >
                    {renderMenuItems(users || [], (item: IUser) => {
                        return {
                            id: item.id,
                            name: item.login,
                        };
                    })}
                </Field>
                <Field
                    error={!!errors?.notice}
                    helperText={errors?.notice}
                    name={'notice'}
                    label={TranslationHelper.translate('Notice')}
                    type={'text'}
                    {...commonProps}
                />
                <Field
                    error={!!errors?.description}
                    helperText={errors?.description}
                    name={'description'}
                    label={TranslationHelper.translate('Description')}
                    type={'text'}
                    {...commonProps}
                />
            </div>
        </Form>
    );
};

export default TicketForm;
